import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { playerSchema } from '../types';

export type CompletePromocodeMutationParams = {
	playerId: number;
};

export const createCompletePromocodeMutation = () =>
	createAuthMutation({
		params: declareParams<CompletePromocodeMutationParams>(),
		request: {
			method: 'PATCH',
			url: '/device/voucher/complete',
			body: (data) => data,
		},
		response: {
			contract: zodContract(playerSchema),
		},
	});
